// @flow @jsx h

import { bem } from '@nrk/dh-utils'
import { h } from 'preact'
import style from './TogglePlayButton.css'

type Props = {
  className?: string,
  paused: boolean,
  onClick: Function
}

export default function TogglePlayButton (props: Props) {
  const { paused } = props
  const className = `${bem(style.togglePlayButton, paused && 'paused')}${
    props.className ? ` ${props.className}` : ''
  }`

  return (
    <button className={className} onClick={props.onClick}>
      <span className='nrk-sr'>
        {paused ? 'Spill av video' : 'Sett video på pause'}
      </span>
      <svg
        className={style.togglePlayButton__pauseIcon}
        aria-hidden='true'
        dangerouslySetInnerHTML={{
          __html: '<use xlink:href="#nrk-media-pause" />'
        }}
      />
      <svg
        className={style.togglePlayButton__playIcon}
        aria-hidden='true'
        dangerouslySetInnerHTML={{
          __html: '<use xlink:href="#nrk-media-play" />'
        }}
      />
    </button>
  )
}
